import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { css } from 'styled-components';
import { color, token } from '../../../../system';
import { colorGrey70, colorRed30 } from '../../../../tokens';
export var getTextInputOverride = function getTextInputOverride(_ref) {
  var disabled = _ref.disabled,
      outlined = _ref.outlined,
      error = _ref.error;
  var result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        background-color: ", ";\n\n        .TextInput-Label {\n            color: ", ";\n        }\n        .TextInput-LabelBackground {\n            color: ", ";\n\n            background: linear-gradient(\n                0,\n                transparent 0 30%,\n                ", " 30% 70%,\n                transparent 70% 100%\n            );\n        }\n    "])), token('body.backgroundColor'), color('neutral.04'), color('neutral.04'), token('body.backgroundColor'));

  if (disabled) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            border-color: ", ";\n        "])), result, colorGrey70);
  }

  if (!outlined && !error && !disabled) {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            border-color: ", ";\n        "])), result, color('neutral.03'));
  }

  if (error) {
    result = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            border-color: ", ";\n        "])), result, colorRed30);
  }

  return result;
};